import { AxiosError } from 'axios'

export class NotFoundError implements CustomError {
  status: 404
  data: any
  name: 'NotFound Error'
  message: string

  constructor(data: any) {
    this.status = 404
    this.data = data
    this.name = 'NotFound Error'
    this.message = data.message || '찾을 수 없습니다'
  }
}

export class UnauthorizedError implements CustomError {
  status: 401
  data: any
  name: 'Unauthorized Error'
  message: string

  constructor(data: any) {
    this.status = 401
    this.data = data
    this.name = 'Unauthorized Error'
    this.message = data.message || '접근 권한이 없는 사용자 입니다'
  }
}

export class NotAcceptableError implements CustomError {
  status: 406
  data: any
  name: 'NotAcceptable Error'
  message: string

  constructor(data: any) {
    this.status = 406
    this.data = data
    this.name = 'NotAcceptable Error'
    this.message = data.message || '접수 할 수 없습니다.'
  }
}

export class BadRequestError implements CustomError {
  status: 400
  data: any
  name: 'BadRequest Error'
  message: string | { [key: string]: string }

  constructor(data: any) {
    this.status = 400
    this.data = data
    this.name = 'BadRequest Error'
    this.message = data.message || '잘못된 요청입니다.'
  }
}

export class InternalServerError implements CustomError {
  status: 500
  data: any
  name: 'InternalServer Error'
  message: string
  constructor(data: any) {
    this.status = 500
    this.data = data
    this.name = 'InternalServer Error'
    this.message = data.message || '서버측 오류입니다.'
  }
}

export const throwError = (error: unknown) => {
  const status = (error as AxiosError).response?.status
  const data = (error as AxiosError).response?.data
  switch (status) {
    case 400:
      throw new BadRequestError(data)
    case 401:
      throw new UnauthorizedError(data)
    case 404:
      throw new NotFoundError(data)
    case 406:
      throw new NotAcceptableError(data)
    case 500:
      throw new InternalServerError(data)
    default:
      throw error
  }
}
